import { Toaster } from "@/components/ui/sonner";
import * as Sentry from "@sentry/react";
import { Router, RouterProvider } from "@tanstack/react-router";
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryProvider } from "../api/custom";
import { useTheme } from "./hooks/useTheme";
import "./index.css";
import "./lib/sentry";
import { routeTree } from "./routes";

const App = () => {
  useTheme();

  return (
    <QueryProvider>
      <RouterProvider router={router} />
      <Toaster />
    </QueryProvider>
  );
};

const router = new Router({
  routeTree,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const root = document.getElementById("root");
if (root) {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <Sentry.ErrorBoundary
        fallback={<h1>An error has occurred. Please refresh the page.</h1>}
      >
        <App />
      </Sentry.ErrorBoundary>
    </React.StrictMode>
  );
}
